//ServiceTypes
export const deliveryTypes = [
    {
        value: 'W2W',
        label: 'На отделение',
    },
    {
        value: 'W2D',
        label: 'Адресная доставка',
    }
];

//TypesOfPayers, TypesOfPayersForRedelivery
export const paidByRecipient = [
    {
        value: 'false',
        label: 'Отправитель',
    },
    {
        value: 'true',
        label: 'Получатель',
    }
];
